var s = Object.defineProperty;
var l = Object.getOwnPropertySymbols;
var m = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
var r = (e, c, t) => c in e ? s(e, c, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[c] = t, o = (e, c) => {
  for (var t in c || (c = {}))
    m.call(c, t) && r(e, t, c[t]);
  if (l)
    for (var t of l(c))
      n.call(c, t) && r(e, t, c[t]);
  return e;
};
var i = (e, c) => {
  var t = {};
  for (var v in e)
    m.call(e, v) && c.indexOf(v) < 0 && (t[v] = e[v]);
  if (e != null && l)
    for (var v of l(e))
      c.indexOf(v) < 0 && n.call(e, v) && (t[v] = e[v]);
  return t;
};
import * as a from "react";
const g = (v) => {
  var h = v, {
    title: e,
    titleId: c
  } = h, t = i(h, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ a.createElement("svg", o({ height: 32, viewBox: "0 0 32 32", width: 32, xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", "aria-labelledby": c }, t), e ? /* @__PURE__ */ a.createElement("title", { id: c }, e) : null, /* @__PURE__ */ a.createElement("path", { d: "m27.7492008 30.5694934v-8.7210413h-2.8610131c-2.3894446-.0212907-4.3107561-1.9727168-4.2948857-4.3622036v-8.71935832c-.0298687-4.77896572 3.8142518-8.68030384 8.5931372-8.7210413.7938031.01199469 1.4294107.66187716 1.423812 1.45575082v29.0678937c0 .790047-.6404968 1.4305066-1.4305438 1.4305066-.7900469 0-1.4305066-.6404596-1.4305066-1.4305066zm-4.2898367-21.80260322v8.72104132c-.003586.382789.1455059.7512288.4142887 1.0238018.2687829.272573.6350991.426809 1.0179008.4285831h2.8610131v-15.80120741c-2.5416495.68537354-4.3038483 2.99536669-4.2932026 5.62778119zm-15.73725539 21.80260322v-14.5356298h-1.42714068c-2.38656401-.0249644-4.30519598-1.9721654-4.294927-4.3588377v-10.1734262c-.00280368-.79534487.63527499-1.44468375 1.43054794-1.45575082.7964424.00832529 1.43611344.65928464 1.43050658 1.45575082v10.1734262c-.00268747.3825212.14669592.7504419.41528558 1.0228189.26858965.2723771.63438266.4268973 1.01690395.429566h1.42882363v-11.6258111c0-.79004697.64045961-1.43050658 1.43050658-1.43050658s1.43050661.64045961 1.43050661 1.43050658v11.6258111h1.4305066c.7955113-.0074039 1.435177-.6568528 1.4305065-1.4523849v-10.1734262c-.0256011-.52762594.2413144-1.02650649.6944614-1.29798832.453147-.27148184 1.0189435-.27148184 1.4720904 0 .453147.27148183.7200625.77036238.6944614 1.29798832v10.1734262c.0130915 2.3864993-1.9051058 4.3347859-4.2915197 4.3588377h-1.4305066v14.528898c0 .5110708-.272653.9833197-.71525331 1.2388551-.44260028.2555354-.98790631.2555354-1.4305066 0-.44260028-.2555354-.71525329-.7277843-.71525328-1.2388551z" }));
};
export {
  g as default
};
